module.exports = __webpack_public_path__ + "static/media/openLink.55dff500.svg";